export const BETA_RECORDING_LAYOUT_STORAGE_KEY = "recording-studio-beta-layout";
export const CLEAN_BETA_RECORDING_LAYOUT_STORAGE_KEY = "recording-studio-chat-beta-layout";

export function parseBetaRecordingRoute(page = "") {
    const parts = String(page).split("/").filter(Boolean);
    if (parts[0] !== "beta") return null;
    if (parts[1] === "recording-studio" && parts[2]) {
        return { type: "studio", sessionId: parts[2] };
    }
    if (parts[1] === "recording-sessions" && parts[2] === "join" && parts[3]) {
        return { type: "guest", inviteToken: parts[3] };
    }
    return null;
}

export function isRemoteDeviceControlLabRoute(page = "") {
    return Boolean(parseBetaRecordingRoute(page));
}

export function getRecordingInviteTokenFromHash(hash = "") {
    const page = String(hash).replace(/^#\/?/, "");
    const betaRoute = parseBetaRecordingRoute(page);
    if (betaRoute?.type === "guest") return betaRoute.inviteToken;
    const parts = page.split("/").filter(Boolean);
    if (parts[0] === "legacy") parts.shift();
    return parts[0] === "recording-sessions" && parts[1] === "join" ? parts[2] || "" : "";
}

export function getRecordingLayoutStorageKey(experience = "live") {
    return experience === "beta"
        ? CLEAN_BETA_RECORDING_LAYOUT_STORAGE_KEY
        : BETA_RECORDING_LAYOUT_STORAGE_KEY;
}

export function getInitialBetaRecordingLayout(storage, experience = "live") {
    try {
        const value = storage?.getItem(getRecordingLayoutStorageKey(experience));
        if (value === "grid" || value === "teams") return value;
        if (experience === "beta") {
            const liveValue = storage?.getItem(BETA_RECORDING_LAYOUT_STORAGE_KEY);
            if (liveValue === "grid" || liveValue === "teams") return liveValue;
        }
        return "teams";
    } catch {
        return "teams";
    }
}

export function getAvailableRecordingLayouts(experience = "live", isMobile = false) {
    if (isMobile) return ["teams"];
    return ["grid", "teams"];
}

export function getEffectiveRecordingLayout({
    experience = "live",
    layout = "teams",
    isMobile = false,
} = {}) {
    return getAvailableRecordingLayouts(experience, isMobile).includes(layout)
        ? layout
        : "teams";
}

export function getBetaRecordingStageState({
    enabled = false,
    layout = "grid",
    remoteParticipantCount = 0,
} = {}) {
    const remoteCount = Math.max(0, Number(remoteParticipantCount) || 0);
    const teamsWithOthers = enabled && layout === "teams" && remoteCount > 0;
    return {
        teamsWithOthers,
        tileCount: teamsWithOthers ? remoteCount : remoteCount + 1,
    };
}

export function isBetaRecordingSessionSupported(sessionType) {
    return String(sessionType || "").trim().toLowerCase() !== "solo";
}

export function hasRecordingStudioLayouts(experience) {
    return experience === "live" || experience === "beta";
}

export function hasRecordingStudioChat(experience) {
    return experience === "live" || experience === "beta";
}

export function resolveRecordingStudioExperience(experience, sessionType) {
    if (experience === "beta") return "beta";
    if (experience === "live" && isBetaRecordingSessionSupported(sessionType)) return "live";
    return "standard";
}

export function getRecordingStudioTileClassName(baseClassName, {
    isSpeaking = false,
    handRaised = false,
} = {}) {
    if (handRaised) return `${baseClassName} recording-call__tile--hand-raised`;
    if (isSpeaking) return `${baseClassName} recording-call__tile--speaking`;
    return baseClassName;
}
